// Vendor imports
const React = require('react')
const PropTypes = require('prop-types')
const classNames = require('classnames')
// Shared imports
const BemEntity = require('shared/bem')
const { parseTemplate } = require('shared/model-helpers/meta-template')
// Common Client V2 imports
const UserAvatar = require('client-v2/common/components/user-avatar')
// Container imports
const ArticleProfileCollectionsRecord = require('../state/collections-record')
// Convenience; in lieu of JSX transpiling...
const { createElement: tag } = React

const bem = BemEntity('ArticleProfileCollectionsItem')

class ArticleProfileCollectionsItem extends React.PureComponent {

  renderCuratorIcon() {
    if (!this.props.item.isCurator) {
      return null
    }
    return (
      tag('span', {
        className: bem.element('curator-icon')
      })
    )
  }

  renderText() {
    const html = parseTemplate(this.props.item)
    return (
      tag('span', {
        className: bem.element('content'),
        dangerouslySetInnerHTML: { __html: html }
      })
    )
  }

  renderUserIcon() {
    // It is assumed that the first item always exists and is the user
    const [ user ] = this.props.item.items
    return tag(UserAvatar, {
      className: bem.element('user-icon'),
      href: true,
      user
    })
  }

  render() {
    return (
      tag('div', {
        className: classNames(
          this.props.className,
          bem.block()
        )
      },
        this.renderUserIcon(),
        this.renderCuratorIcon(),
        this.renderText()
      )
    )
  }

}

ArticleProfileCollectionsItem.propTypes = {
  // Values
  className: PropTypes.string,
  item: PropTypes.shape(ArticleProfileCollectionsRecord.propTypes).isRequired
}

module.exports = ArticleProfileCollectionsItem
